// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://erqsoqulvuxrhsokiarz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVycXNvcXVsdnV4cmhzb2tpYXJ6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEwMzQ5NTAsImV4cCI6MjA2NjYxMDk1MH0.iq3_aufZVPurM_ZBg-e47oSkVqP8fDCrIvUokk8mdyw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);